import React, { useState, useEffect } from 'react'
import Reusabletable from '../reusableforms/Reusabletable'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/register_template/Leave_register.xlsx"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileformInputMatrix from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrix'
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'
import mainicon from "../../../../assets/register_assets/inputMatix/Leave_Register/mainicon.png"
import { getUserRole } from "./../../../../services/global_redux/globale_actions/Role.action";
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import Branch_id_icon from "../../../../assets/register_assets/inputMatix/Leave_Register/Branch_id_icon.png"
import Client_id_icon from "../../../../assets/register_assets/inputMatix/Leave_Register/Client_id_icon.png"
import Employee_code_icon from "../../../../assets/register_assets/inputMatix/Leave_Register/Employee_code_icon.png"
import Leave_code_icon from "../../../../assets/register_assets/inputMatix/Leave_Register/Leave_code_icon.png"
import Leave_from_icon from "../../../../assets/register_assets/inputMatix/Leave_Register/Leave_from_icon.png"
import Leave_to_icon from "../../../../assets/register_assets/inputMatix/Leave_Register/Leave_to_icon.png"
import Total_Days_icon from "../../../../assets/register_assets/inputMatix/Leave_Register/Total_Days_icon.png"

import { uploadLeaveRegisterFile, getLeaveRegister, updateLeaveById, deleteLeaveById, multiDeleteLeaveRegister } from './../../../../services/register_redux/register_actions/Leave_register.action';

function LeaveRegister({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const dispatch = useDispatch();
    const { date } = useParams();
    const [createData, setCreateData] = useState(null);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const header = [
        { key: "emp_code", value: "Employee Code", input: 'text', readOnly:true  ,icon: Employee_code_icon },
        { key: "leave_code", value: "Leave Code", input: 'text', readOnly:true  ,icon: Leave_code_icon },
        { key: "unit_id", value: "Branch ID", input: 'text',readOnly:true ,icon: Branch_id_icon},
        { key: "client_id", value: "Organization ID", input: 'text',readOnly:true  ,icon: Client_id_icon},
        { key: "leave_applied_date", value: "Leave Applied Date", input: 'date',readOnly:true  ,icon: Leave_from_icon},
        { key: "leave_from", value: "Leave From", input: 'date' ,icon: Leave_from_icon},
        { key: "leave_to", value: "Leave To", input: 'date' ,icon: Leave_to_icon},
        { key: "total_days", value: "Total Days", input: 'number' ,icon: Total_Days_icon},
        { key: "leave_type", value: "Leave Type", input: 'text', readOnly: true },
        { key: "part_of_day", value: "Part of Day", input: 'text' },
        { key: "reason", value: "Reason", input: 'text' },
    ];
    
    const [actionChecked, setActionChecked] = useState("");



    const fetchdata = async () => {
        if (!date) return;
        setLoading(true);
        try {
            const response = await dispatch(getLeaveRegister(date));
            const data = Array.isArray(response?.data) ? response.data : [];
            setGetData(data);
        } catch (err) {
            console.error("Failed to fetch leave register:", err);
            setGetData([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchdata();
    }, [dispatch, date]);

    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);

    //         const formData = new FormData();
    //         formData.append('file', file);
    //         try {
    //             const response = await dispatch(uploadLeaveRegisterFile(formData));
    //             if (response.success == true) {
    //                 showSnackbar(response.message.data.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };



        const downloadBase64Excel = (contentBase64, filename) => {
        try {
            const byteCharacters = atob(contentBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'leave_register_failed_rows.xlsx';
            a.click();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error('Download failed:', e);
            showSnackbar('Failed to download error file', 'error');
        }
    };

    const handleFileUpload = async () => {
        if (file) {
            setLoading(true);
            const formData = new FormData();
            formData.append('file', file);
            try {
                const response = await dispatch(uploadLeaveRegisterFile(formData, date));
                console.log("upload leave register response", response);                
                if (response.success == true) {
                    const msg = response.message;
                    showSnackbar(msg.message || 'Upload completed', 'success');
                    setLoading(false);
                    fetchdata();
                    setFile(null);
                    setActionChecked("create");
                    if (msg.error_file && msg.error_file.content_base64) {
                        downloadBase64Excel(msg.error_file.content_base64, msg.error_file.filename);
                    }
                } else {
                    const err = response.message;
                    const displayError = Array.isArray(err) ? err.slice(0, 3).join('; ') + (err.length > 3 ? ` ... and ${err.length - 3} more` : '') : (err && err.error) || err || 'Upload failed';
                    showSnackbar(displayError, 'warning');
                    setLoading(false);
                }
            } catch (error) {
                showSnackbar('An error occurred', 'error');
                setLoading(false);
            }
        }
    };
    
        const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteLeaveRegister(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }

    const handleSaveClick = async (e) => {
        setLoading(true);
        try {
            const response = await dispatch(updateLeaveById(editedValues.id, editedValues));
            console.log("updateLeaveById message", response);
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteLeaveById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());    
            const rawPermissions = response?.data?.permissions;
    
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
    
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "InputMatrix" && module === "InputMatrix") {
                    const employeePermission = sub_module.find(sub => sub.name === 'Leave Register');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                        setEditData(employeePermission.action.edit);
                        setDeleteData(employeePermission.action.delete);
                    }
                }
            });
    
        } catch (err) {
            console.error("Failed to fetch permissions:", err);
        }
    };
    
   
    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            if(date === new Date(response.data[0].current_month).toISOString().split('T')[0]){
                getUserPermission();
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };
    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch]);
    return (
        <div className='container-fluid'>
            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Leave Register'}
                setLoading={setLoading}
                filestemp={files}
                showSnackbar={showSnackbar}
                date={date}
            /> */}
            {createData ? 
            // <ImportFileform
            //     setFiledata={setFile}
            //     title={'Leave Register'}
            //     filestemp={files}
            //     handleFileUpload={handleFileUpload}

            // />
            <ImportFileformInputMatrix
                setFiledata={setFile}
                title={'Leave Register'}
                filestemp={files}
                handleFileUpload={handleFileUpload}
                date={date}
                File={file}
            />:<ImportFileformInputMatrixclientData
                date={date}
                
            />
            }
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Leave Register'}
            data={getData}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {editData}
            getDeletePermission = {deleteData}
            date={date}
            submitdelete={submitdelete}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            mainIconColor={"#8280ff"}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
        </div>
    )
}

export default LeaveRegister
